@if (xploreItem.multiMedia.length > 0) {
  <div #sliderHorizRef class="keen-slider h-full w-full">
    @for (image of xploreItem.multiMedia; track trackByMedia($index, image)) {
      <div class="keen-slider__slide">
        <img [ngSrc]="getImage(image)" (error)="onImageError($event)"
          alt=""
          class="object-cover h-full w-full block"
          height="1920"
          width="1080"
          [attr.loading]="$index === 0 && isPrimaryMedia ? null : 'lazy'"
          [attr.decoding]="$index === 0 && isPrimaryMedia ? 'sync' : 'async'"
          [attr.fetchpriority]="$index === 0 && isPrimaryMedia ? 'high' : 'low'">
        @if (image.userAccount; as photoAuthor) {
          <button type="button"
            class="media-credit"
            (click)="goToUserProfile(photoAuthor)"
            aria-label="Vai al profilo autore foto">
            <span class="media-credit__icon-wrap" aria-hidden="true">
              <svg class="media-credit__icon" fill="none" stroke-width="2.2" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <use [attr.xlink:href]="ImageManager.cameraIcon" />
              </svg>
            </span>
            <span class="media-credit__text">{{ photoAuthor.displayedName }}</span>
          </button>
        }
      </div>
    }
  </div>
  @if (xploreItem.multiMedia.length > 1) {
    <div class="media-dots" aria-hidden="true">
      @for (image of xploreItem.multiMedia; track trackByMedia($index, image)) {
        <span class="media-dots__dot" [class.media-dots__dot--active]="$index === currentMediaIndex()"></span>
      }
    </div>
  }
} @else {
  <img [ngSrc]="ImageManager.getPlaceholderImage()" alt="" class="object-cover h-full w-full block"
    height="1920" width="1080" loading="lazy" decoding="async">
}
